<template>
  <div v-if="isLoaded">
    <div class="wraper" v-if="!isProjectLoading">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <ProjectHeader></ProjectHeader>
      </div>
      <div class="container-fluid">
        <div
          v-if="notifications.items.length > 0"
          class="notification-list-container"
        >
          <div class="notification-list-area">
            <div
              class="row"
              v-for="notification in notifications.items"
              style="margin-bottom: 20px"
            >
              <div
                v-if="notification.POSITION_MESSAGE == 'MESSAGE_LEFT'"
                class="notification-row-container"
              >
                <div
                  class="notification-col-text"
                  style="background-color: #6cb9e8;padding: 20px 20px;border-radius: 6px"
                >
                  <div v-html="notification.UF_MESSAGE"></div>
                  <div>
                    <a
                      :href="siteUrl + notification.UF_FILE"
                      target="_blank"
                      class="file"
                      v-if="notification.UF_FILE"
                      >{{ notification.UF_FILE_NAME | fileName }}</a
                    >
                  </div>
                  <div class="notification-butt-container">
                    <a
                      v-if="notification.UF_AUTHOR_ID !== currentUser.ID"
                      @click="replyToMessage(notification)"
                    >
                      Ответить
                    </a>
                  </div>
                </div>
                <div class="notification-col-data">
                  <div>{{ notification.UF_AUTHOR_NAME }}</div>
                  <div>
                    <strong
                      style="color: #00a651"
                      v-if="notification.UF_IS_DECLARER"
                      >{{ notification.UF_GROUP_NAME_AUTHOR }}</strong
                    >
                    <strong style="color: #c9302c" v-else>{{
                      notification.UF_GROUP_NAME_AUTHOR
                    }}</strong>
                  </div>
                  <div>{{ notification.UF_DATE_CREATE }}</div>
                  <div v-if="canEdit">
                    <button
                      type="button"
                      class="btn btn-danger"
                      @click="deleteMessage(notification.ID)"
                    >
                      Удалить
                    </button>
                  </div>
                </div>
              </div>
              <div
                v-if="notification.POSITION_MESSAGE == 'MESSAGE_RIGHT'"
                class="notification-row-container"
              >
                <div
                  class="notification-col-data"
                  style="width: 250px;"
                  :style="'margin-left: ' + notification.MARGIN_LEFT + 'px;'"
                >
                  <div class="pull-right">
                    {{ notification.UF_AUTHOR_NAME }}
                  </div>
                  <div style="clear: both"></div>
                  <div class="pull-right">
                    <strong
                      style="color: #00a651"
                      v-if="notification.UF_IS_DECLARER"
                      >{{ notification.UF_GROUP_NAME_AUTHOR }}</strong
                    >
                    <strong style="color: #c9302c" v-else>
                      {{ notification.UF_GROUP_NAME_AUTHOR }}
                    </strong>
                  </div>
                  <div style="clear: both"></div>
                  <div class="pull-right">
                    {{ notification.UF_DATE_CREATE }}
                  </div>
                  <div style="clear: both"></div>
                  <div class="pull-right" v-if="canEdit">
                    <button
                      type="button"
                      class="btn btn-danger"
                      @click="deleteMessage(notification.ID)"
                    >
                      Удалить
                    </button>
                  </div>
                </div>
                <div
                  class="notification-col-text"
                  style="background-color: #6cb9e8;padding: 20px 20px;border-radius: 6px"
                >
                  <div v-html="notification.UF_MESSAGE"></div>
                  <div>
                    <a
                      :href="siteUrl + notification.UF_FILE"
                      target="_blank"
                      class="file"
                      v-if="notification.UF_FILE"
                      >{{ notification.UF_FILE_NAME | fileName }}</a
                    >
                  </div>
                  <div class="notification-butt-container">
                    <a
                      v-if="notification.UF_AUTHOR_ID !== currentUser.ID"
                      @click="replyToMessage(notification)"
                    >
                      Ответить
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="padding: 20px 30px;" v-else>
          <strong>Уведомлений нет</strong>
        </div>
        <div class="row">
          <div class="col-xs-6">
            <Pagination
              :pages="pages"
              :currentPage.sync="currentPage"
            ></Pagination>
          </div>
        </div>
        <a name="addMessage" id="addMessage"></a>
        <div class="row" style="margin-bottom: 20px" v-if="canWrite">
          <div class="col-md-8 df-ac" style="margin-bottom: 15px;">
            <label style="margin-right: 10px; margin-bottom: 0px">Кому:</label>
            <Multiselect
              v-model="selectedAdressats"
              :options="adressatOptions"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Выберите адресатов"
              class="multiselect--notification"
              label="UF_ADRESSAT_NAME"
              track-by="UF_ADRESSAT_ID"
            >
            </Multiselect>
          </div>

          <div class="col-md-8" v-if="isViewAreaReplay">
            <p><strong>Ответ на сообщение</strong>:</p>
            <blockquote
              v-html="replayMessage"
              style="border: 1px solid #cecece; background: #fcf3cf; padding-top: 10px;"
            ></blockquote>
          </div>

          <div class="col-md-8">
            <div
              class="alert alert-warning"
              role="alert"
              v-if="!editorDataValidT"
            >
              Сообщение не должно превышать 1000 символов
            </div>
            <vue-editor
              ref="editor"
              v-model="editorData"
              :editor-toolbar="toolbar"
            ></vue-editor>
          </div>
        </div>
        <div class="row" style="margin-bottom: 20px" v-if="canWrite">
          <div class="col-md-8">
            <div style="display: inline-block">
              <input
                type="file"
                ref="file"
                @change="onChange"
                style="display: none"
              />
              <button
                type="button"
                @click="$refs.file.click()"
                class="btn btn-default"
              >
                Добавить документ
              </button>
            </div>
            <div style="display: inline-block">
              &nbsp;&nbsp;&nbsp;{{ uFile }}
            </div>
          </div>
        </div>
        <div class="row" v-if="canWrite">
          <div class="col-md-8">
            <button
              type="button"
              class="btn btn-success"
              :disabled="!editorDataValid"
              @click="addMessage"
            >
              Отправить
            </button>

            <button
              type="button"
              class="btn btn-style-big btn-default"
              @click="clearMessage"
            >
              Отмена
            </button>
          </div>
        </div>
      </div>
    </div>
    <project-menu></project-menu>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import {
  FETCH_PROJECT,
  FETCH_DIRECTORY,
  FETCH_NOTIFICATIONS,
  SET_IS_VIEW_ALL_EXPERTISE
} from "@/store/actions.type";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ProjectHeader from "@/components/project/partial/ProjectHeader";
import { NotificationService, ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Pagination from "@/components/Pagination";
import ProjectMenu from "@/components/project/partial/ProjectMenu";
import Multiselect from "vue-multiselect";

Vue.filter("fileName", function(value) {
  let l = value.split("/");

  return l[l.length - 1];
});

export default {
  name: "Notifications",
  title: "Уведомления",
  data() {
    return {
      siteUrl: "",
      file: "",
      uFile: "",
      editorDataValid: false,
      editorDataValidT: true,
      canEdit: false,
      canWrite: false,
      itemsPerPage: 100,
      currentPage: 1,
      editor: ClassicEditor,
      editorData: "",
      toolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6]
          }
        ],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          {
            align: ""
          },
          {
            align: "center"
          },
          {
            align: "right"
          },
          {
            align: "justify"
          }
        ],
        ["blockquote", "code-block"],
        [
          {
            list: "ordered"
          },
          {
            list: "bullet"
          },
          {
            list: "check"
          }
        ],
        [
          {
            indent: "-1"
          },
          {
            indent: "+1"
          }
        ], // outdent/indent
        [
          {
            color: []
          },
          {
            background: []
          }
        ], // dropdown with defaults from theme
        ["link"],
        ["clean"] // remove formatting button
      ],
      selectedAdressats: [],
      replayMessage: "",
      isViewAreaReplay: false,
      isLoaded: false
    };
  },
  components: {
    Multiselect,
    ProjectMenu,
    Pagination,
    ProjectHeader
  },
  watch: {
    currentPage(newValue) {
      this.listConfig.page = newValue;
      this.fetchNotifications();
    },
    itemsPerPage(newValue) {
      this.listConfig.limit = newValue;
      this.fetchNotifications();
    },
    editorData() {
      let l = this.$refs.editor.quill.getLength();
      this.editorDataValid = true;
      this.editorDataValidT = true;
      if (l === 0 || l > 1000) {
        // this.editorDataValid = false;
      }
      if (l > 1000) {
        //this.editorDataValidT = false;
      }
    },
    notifications() {
      this.setDefaultAdressat();
    }
  },
  computed: {
    adressatOptions() {
      return this.notifications.LIST_ADRESSATS || [];
    },
    listConfig() {
      const q = {
        ID: this.$route.params.id,
        page: this.currentPage,
        limit: this.itemsPerPage
      };
      return q;
    },
    pages() {
      if (this.isLoading || this.notifications.counts <= this.itemsPerPage) {
        return [];
      }
      return [
        ...Array(
          Math.ceil(this.notifications.counts / this.itemsPerPage)
        ).keys()
      ].map(e => e + 1);
    },
    ...mapGetters([
      "project",
      "isLoading",
      "directory",
      "currentUser",
      "notifications"
    ])
  },
  async created() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");
    await this.$store
      .dispatch(FETCH_DIRECTORY, ["status"])
      .then(() => {}, this);

    this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"]).then(() => {
      this.fetchProject();
    }, this);
  },
  mounted() {
    this.setDefaultAdressat();
  },
  methods: {
    setDefaultAdressat() {
      let defaultAdressat;
      if (
        this.notifications.LIST_ADRESSATS &&
        this.notifications.LIST_ADRESSATS.length
      ) {
        defaultAdressat = this.notifications.LIST_ADRESSATS.find(
          adressat =>
            adressat.UF_ADRESSAT_ID ===
            this.notifications.DEFAULT_SET_ADRESSAT_ID
        );
      }
      this.selectedAdressats = defaultAdressat ? [defaultAdressat] : [];
    },
    replyToMessage(notification) {
      const adressat = this.notifications.LIST_ADRESSATS.find(
        adressat => adressat.UF_ADRESSAT_ID === notification.UF_AUTHOR_ID
      );
      if (adressat) {
        this.selectedAdressats = [
          { ...adressat, UF_PARENT_ID: notification.ID }
        ];
      } else {
        const newAdressat = {
          UF_ADRESSAT_ID: notification.UF_AUTHOR_ID,
          UF_ADRESSAT_NAME: `${notification.UF_AUTHOR_NAME}, ${notification.UF_GROUP_NAME_AUTHOR}`,
          UF_GROUP_ID_ADRESSAT: notification.UF_GROUP_ID_AUTHOR,
          UF_PARENT_ID: notification.ID
        };
        this.notifications.LIST_ADRESSATS.push(newAdressat);
        this.selectedAdressats = [newAdressat];
      }
      //this.editorData = `<blockquote>${notification.UF_MESSAGE}</blockquote><br>`;
      /*this.editorData =
        "<blockquote class='replay-text'>" +
        notification.UF_MESSAGE.replace(/<(.|\n)*?>/g, "") +
        "</blockquote><br/>";*/
      this.editorData = "";
      this.isViewAreaReplay = true;
      this.replayMessage = notification.UF_MESSAGE;
      console.log(notification.UF_MESSAGE);
      window.getSelection().removeAllRanges();
      location.hash = "#addMessage";
    },
    addMessage() {
      const adressatListSet = this.selectedAdressats.map(adressat => ({
        UF_ADRESSAT_ID: adressat.UF_ADRESSAT_ID,
        UF_ADRESSAT_NAME: adressat.UF_ADRESSAT_NAME,
        UF_GROUP_ID_ADRESSAT: adressat.UF_GROUP_ID_ADRESSAT
      }));
      const parentId = this.selectedAdressats[0].UF_PARENT_ID || null;
      NotificationService.addMessageProject(this.$route.params.id, {
        UF_MESSAGE: this.editorData,
        UF_FILE_NAME: this.uFile,
        UF_FILE: this.file,
        ADRESSAT_LIST_SET: adressatListSet,
        UF_PARENT_ID: parentId
      }).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.editorData = "";
          this.uFile = "";
          this.file = "";
          this.isViewAreaReplay = false;
          this.replayMessage = "";
          this.fetchNotifications();
        }
      }, this);
    },
    clearMessage() {
      this.editorData = "";
      this.uFile = "";
      this.file = "";
      this.isViewAreaReplay = false;
      this.replayMessage = "";
      this.fetchNotifications();
    },
    fetchNotifications() {
      this.$store.dispatch(FETCH_NOTIFICATIONS, this.listConfig);
    },
    onChange(e) {
      let files = e.target.files;

      for (var i = 0; i < files.length; i++) {
        let file = files[i];

        let reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
          // Make a fileInfo Object
          let fileInfo = {
            name: file.name,
            type: file.type,
            size: Math.round(file.size / 1000) + " kB",
            base64: reader.result,
            file: file
          };
          this.uFile = file.name;
          this.file = fileInfo.base64;
        };
      }
    },
    deleteMessage(id) {
      if (confirm("Удалить сообщение?")) {
        NotificationService.deleteMessageProject(
          this.$route.params.id,
          id
        ).then(() => {
          this.fetchNotifications();
        }, this);
      }
    },
    async fetchProject() {
      await this.$store.dispatch(FETCH_PROJECT, this.$route.params.id);
      this.canEdit = false;
      this.canWrite = false;
      await ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
        if (typeof data.IS_ONLY_READ_NOTIFICATION !== "undefined") {
          this.canEdit = !data.IS_ONLY_READ_NOTIFICATION;
          this.canWrite =
            data.IS_ONLY_READ_NOTIFICATION == 0 ||
            data.IS_ONLY_READ_NOTIFICATION == 2;
        }
        this.fetchNotifications();

        if (data.IS_VIEW_NOTIFICATIONS == 1) {
          this.isLoaded = true;
        }
      }, this);
    },
    getStatus: function(id) {
      let t = this.directory.status.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0];
      }
    }
  }
};
</script>

<style scoped></style>
